// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import Vuetify from 'vuetify'
import '../node_modules/vuetify/dist/vuetify.min.css'
import Croppa from 'vue-croppa'
import '../node_modules/vue-croppa/dist/vue-croppa.css'
import Notify from 'vue-notifyjs'
import '../node_modules/vue-notifyjs/themes/material.css'
import VueEvents from 'vue-events'
import PfxBackendApiPlugin from './utils/PfxBackendApiPlugin.js'
import PfxUtilsPlugin from './utils/PfxUtilsPlugin.js'
import App from './App.vue'
import router from './router'
import store from './store/index'
import moment from 'moment-timezone'
import 'vue-animate/dist/vue-animate.min.css'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.config.productionTip = false

Vue.use(Vue2Filters)
Vue.use(Vuetify, {
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    // custom colors below
    pfxBrand: '#0277bd',
    brand: '#0277bd',
    brandgreen: '#31cb83',
    gold: '#FFD44F',
    formerror: '#e32122'
  }
})

VTooltip.options.defaultPlacement = 'left'
VTooltip.options.defaultTrigger = 'click'

Vue.use(Croppa)
Vue.use(Notify, { type: 'info', verticalAlign: 'top', horizontalAlign: 'center', timeout: 5000 })
Vue.use(VueEvents)
Vue.use(PfxBackendApiPlugin)
Vue.use(PfxUtilsPlugin)

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.filter('prettyMoney', (value) => {
  const formatUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatUSD.format(value)
})

// date = integer, epoch in milliseconds
// timezome = IANA timezone string, e.g. America/Log_Angeles or Etc/UTC
Vue.filter('prettyDateTime', (date, timezone) => {
  if (!timezone) { timezone = moment.tz.guess() }
  return moment.tz(date, timezone).format('ddd MMM DD YYYY h:mmA z')
})
Vue.filter('prettyDateTimeShort', (date, timezone) => {
  if (!timezone) { timezone = moment.tz.guess() }
  return moment.tz(date, timezone).format('MMM DD YYYY h:mmA z')
})
Vue.filter('prettyDate', (date, timezone) => {
  if (!timezone) { timezone = moment.tz.guess() }
  return moment.tz(date, timezone).format('ddd MMM DD YYYY')
})
Vue.filter('prettyDateShort', (date, timezone) => {
  if (!timezone) { timezone = moment.tz.guess() }
  return moment.tz(date, timezone).format('MMM DD YYYY')
})
Vue.filter('prettyTime', (date, timezone) => {
  if (!timezone) { timezone = moment.tz.guess() }
  return moment.tz(date, timezone).format('h:mmA z')
})
Vue.filter('delta', (date) => {
  return Math.floor((date - Vue.prototype.$PfxUtils.currentDate().getTime()) / 1000)
})
// delta = seconds until countdown
Vue.filter('countdownTimer', (delta) => {
  if (delta < 0) delta = 0
  const secs = delta % 60
  const mins = Math.floor(delta / 60 % 60)
  const hours = Math.floor(delta / 60 / 60 % 24)
  const days = Math.floor(delta / 60 / 60 / 24)

  let timer = ''
  if (days) { timer += days + 'd ' }
  if (days || hours) { timer += hours + 'h ' }
  if (days || hours || mins) { timer += mins + 'm '}
  timer += secs + 's '
  return timer
})

Vue.filter('prettySF', (squareFeet) => {
  if (!squareFeet) return ''
  if (squareFeet >= 43560) {
    return (squareFeet / 43560).toFixed(2) + ' Acres'
  }
  return squareFeet + ' SF'
})

Vue.filter('filesize', (size) => {
  const i = size <= 0 ? 0 : Math.floor( Math.log(size) / Math.log(1024) )
  return ( size / Math.pow(1024, i) ).toFixed(0) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
})

Vue.filter('convertLinebreaks', (text) => {
  text = text || ''
  return text.replace(/\n/g, '<br/>')
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js